export default __webpack_public_path__ + "static/media/weborgan.18afdeea.png";